import React, { useEffect, useState } from 'react'
import Layout2 from "@/components/Layout/Layout2";
import { onlineOrderingLinks } from "@/components/lib/SidebarLinks";
import LeftBar2 from "@/components/Layout/LeftBar2";
import PathMap from '@/components/lib/PathMap';
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import AllNoticeTable from '@/components/online-ordering/settings/Notice/AllNoticeTable';
import { useFilter } from '@/hooks/useFilter';
import { useDispatch, useSelector } from 'react-redux';
import { usePagination } from '@/hooks/usePagination';
import { useSearch } from '@/hooks/useSearch';
import { fetchAllNotice } from '@/redux/slice/order-ordering-slice/notice-slice';
import useAuth from '@/hooks/useAuth';
import Paginat from '@/components/lib/paginat';
import TableSkeleton from '@/components/skeleton/table-skeletion';

const Notice = () => {
  const { notices, getLoading } = useSelector((state) => state.onlineOrdering.notice);
  
  const { user } = useAuth();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchAllNotice(user?.restaurant_id));
  }, [user?.restaurant_id]);

  const [filters, setFilters] = useState({
    status: "",
  });
  const [searchText, setSearchText] = useState("");
  const [perPage, setPerPage] = useState(10);
  const filteredData = useFilter(notices, filters, {
    delay: 300,
    defaultFilter: (item) => item.status !== "draft",
  });

  const searchData = useSearch(
    filteredData,
    searchText,
    ["item_no", "name", "description"],
    300
  );
  const { paginatedData, paginationInfo, onPageChange } = usePagination(
    searchData,
    perPage
  );

  // const { groupLoading } = useFetchAllMenuData(user?.restaurant_id, id, {fetchOnly});
  // if (groupLoading) return <EssentialSkeleton />;
  if (getLoading) return <TableSkeleton links={onlineOrderingLinks} />;

  return (
    <Layout2
      LeftBar={<LeftBar2 sidebarLinks={onlineOrderingLinks} />}
    >
      <div className="container">
        <div className='flex justify-between items-center'>
          <PathMap 
            pageName={{ title: "Notice" }}
            paths={[
              // { name: "Home", path: "/home" },
              // { name: "Online Ordering", path: "/online-ordering" },
              { name: "Settings", path: "/onlineordering/settings/website-settings" },
              { name: "Notice" },
            ]}
          />
          <Link to={"/onlineordering/settings/notice/create"}>
            <Button>
              <Plus /> Create Notice
            </Button>
          </Link>
        </div>

        <div>
          <AllNoticeTable notices={paginatedData}/>
        </div>
        <div>
          <Paginat
            pagination={paginationInfo}
            onPageChange={onPageChange}
            className="mt-4"
          />
        </div>
      </div>
    </Layout2>
  )
}

export default Notice